var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-tree-view',{ref:"treeViewRef",attrs:{"id":"sideMenu","items":_vm.items,"key-expr":"path","parent-id-expr":"upMenuId","selection-mode":"single","focus-state-enabled":false,"expand-event":"click","width":"100%","no-data-text":""},on:{"item-click":_vm.handleItemClick,"item-expanded":_vm.onItemExpanded}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1937fe4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideMenu.vue
// module id = null
// module chunks = 